import { FC, ReactElement, ReactNode } from 'react';
import { isMobile } from '@direct-frontend/platform-code';

import { type ColorlessIconProps } from '../../icons/types';
import { IconAlert, IconError, IconInfo, IconSelectContour, IconYna } from '../../icons/colorless';
import { SkinRole, SkinColor } from '../../lib/skin/getColorSkin/generated/types';
import { StackGap } from '../Stack/types';
import { VStack } from '../Stack';

import { InfoColor, InfoColorConfig } from './types';

/**
 * Получение иконки по цветовой теме блока
 */
export const defaultIcons: Record<InfoColor, FC<ColorlessIconProps>> = {
    island: IconInfo,
    warning: IconAlert,
    message: IconInfo,
    error: IconError,
    success: IconSelectContour,
    info: IconInfo,
    inverted: IconInfo,
    ai: IconYna,
};

/**
 * Маппинг цветов на скины
 */
export const defaultSkinMap: Record<InfoColor, SkinRole | SkinColor> = {
    island: 'gray-neutral',
    warning: 'warning-lc',
    message: 'message-lc',
    error: 'error-lc',
    success: 'success-lc',
    info: 'info-lc',
    inverted: 'gray-neutral',
    ai: 'ai-high-contrast',
};

/**
 * Создает конфигурацию цветов для компонента
 */
export function createInfoColorConfig(
    customIcons?: Partial<Record<InfoColor, FC<ColorlessIconProps>>>,
    customSkinMap?: Partial<Record<InfoColor, SkinRole | SkinColor>>,
): InfoColorConfig {
    return {
        icons: { ...defaultIcons, ...customIcons },
        skinMap: { ...defaultSkinMap, ...customSkinMap },
    };
}

/**
 * Общая функция для добавления обертки с изображением
 */
export function addImageBlockWrapper(
    imageBlock: ReactNode | false,
    content: ReactElement<{ className: string }>,
    alignItems?: 'flex-start',
): ReactElement<{ className: string }> {
    if (imageBlock) {
        return (
            <VStack alignItems={alignItems}>
                {imageBlock}
                {content}
            </VStack>
        );
    }
    return content;
}

/**
 * Общая функция для получения gap контейнера
 */
export function getContainerGap(customMobileGap?: StackGap): StackGap {
    if (isMobile()) {
        return customMobileGap || '16';
    }
    return 'current-geometry';
}
